import { render, staticRenderFns } from "./PersonalInfomationTemplate.vue?vue&type=template&id=63ebcb9f&scoped=true&"
import script from "./PersonalInfomationTemplate.vue?vue&type=script&lang=ts&"
export * from "./PersonalInfomationTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalInfomationTemplate.vue?vue&type=style&index=0&id=63ebcb9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebcb9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VRadio,VRadioGroup,VSelect,VTextarea})
